import axios from "@/lib/axios";

const getEditInfo = () => {
  return axios.get("/customer/edit_info");
}

export default getEditInfo;